import { fadeInAnimationLong, fadeInAnimationShort, styles } from 'consts';
import styled from 'styled-components';

const { animationLong, animationShort, white, primaryBlack, blueSecondary, fontMBank } = styles;

export const PaymentExpiredScreenContainer = styled.div`
  border-radius: 0.5rem;
  background: ${white};
  text-align: center;
  color: ${white};
  padding: 3.3125rem 1rem;
  position: relative;
`;

export const PaymentExpiredScreenWrapper = styled.div`
  animation: ${animationShort};
  ${fadeInAnimationShort};
`;

export const PaymentExpiredScreenStatus = styled.div`
  font-size: 2rem;
  line-height: 1.25;
  text-align: center;
  color: ${primaryBlack};
  max-width: 25rem;
  margin: 0 auto;
`;

export const PaymentExpiredScreenStatusText = styled.div`
  font-size: 2rem;
  font-weight: bold;
  line-height: 1.25;
  text-align: center;
  color: ${blueSecondary};
  margin-bottom: 1.5rem;
  max-width: 24rem;
  margin: 0 auto;
`;

export const PaymentExpiredScreenIcon = styled.div`
  animation: ${animationLong};
  ${fadeInAnimationLong};
  img {
    width: 12.5rem;
    height: 9.375rem;
  }
  margin-bottom: 0.5rem;
`;

export const PaymentExpiredScreenMessage = styled.div`
  color: ${primaryBlack};
  font-family: ${fontMBank};
  font-size: 1rem;
  line-height: 1.32;
  max-width: 28.75rem;
  margin: 0 auto;
  font-weight: 500;
`;
